// src/sections/@kanban/kanban-filters-popover.js
import { useCallback } from 'react';
import {
    Stack,
    TextField,
    IconButton,
    InputAdornment
} from '@mui/material';

import Iconify from 'src/components/iconify';
import { useBoolean } from 'src/hooks/use-boolean';
import { KanbanCardCreateModal } from './kanban-card-create-modal';

export default function KanbanFiltersPopover({ filters, onFilters, onClose }) {
    const add = useBoolean();

    const handleFilterName = useCallback(
        (event) => {
            onFilters('name', event.target.value.toLowerCase()); // lowercase filter
        },
        [ onFilters ]
    );

    return (
        <>
            <Stack spacing={ 1.5 } sx={ { p: 2, width: 260 } }>
                <TextField
                    fullWidth
                    placeholder="Search..."
                    value={ filters.name }
                    onChange={ handleFilterName }
                    InputProps={ {
                        startAdornment: (
                            <InputAdornment position="start">
                                <Iconify icon="eva:search-fill" sx={ { color: 'text.disabled' } } />
                            </InputAdornment>
                        ),
                    } }
                />

                <IconButton onClick={ add.onTrue }>
                    <Iconify icon="material-symbols:person-add-rounded" width={ 24 } />
                </IconButton>
            </Stack>

            <KanbanCardCreateModal open={ add.value } onClose={ add.onFalse } />
        </>
    );
}
